//Lấy DNS môi trường
// process.env.VUE_APP_SERVERHOST = location.hostname;
// process.env.VUE_APP_SERVERHOST = ''

//*** DEV ***//
const hostDev = 'https://localhost:44300/v1';

//*** Local ***//
const hostLocal = 'APIS/PaymentPartnerAPI/v1';

//*** Test ***//
const hostTest = 'APIS/PaymentPartnerAPI/v1';

//*** Production ***//
const hostProduction = 'APIS/PaymentPartnerAPI/v1';

const api = {
  development: hostDev,
  local: hostLocal,
  test: hostTest,
  production: hostProduction
};

export default api[process.env.NODE_ENV];
